import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=488e93e2&scoped=true"
var script = {}
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=488e93e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e93e2",
  null
  
)

export default component.exports